export default defineNuxtRouteMiddleware((to, from) => {
  if(to.path === '/') {
    return navigateTo({path: '/home', query: to.query});
  }else {
    return ;
  }
})